import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { ContentLoader, Margin, Text } from 'shared/components'

import SponsorFormConfirm from './components/sponsorFormConfirm'

import * as styles from './styles'

const SignupSponsorConfirmComponent = ({
  onSubmit,
  getPreRegSponsorPublicInfo,
}) => {
  const [initialValues, setInitialValues] = useState({})
  useEffect(() => {
    const fetchData = async () => {
      const sponsor = await getPreRegSponsorPublicInfo()
      setInitialValues(sponsor)
    }

    fetchData()
  }, [])

  return initialValues.fullName ? (
    <Margin resetWhen="phone" css={styles.signupContainer}>
      <section css={styles.signupSection}>
        <Margin as="section" bottom={2}>
          <Text as="h2" size={24} white italic bold>
            Confirm your registration
          </Text>
        </Margin>
        <Margin as="section" tb={2}>
          <SponsorFormConfirm
            initialValues={initialValues}
            onSubmit={onSubmit}
          />
        </Margin>
      </section>
    </Margin>
  ) : (
    <div css={styles.loaderWrapper}>
      <ContentLoader loading={true} />
    </div>
  )
}

SignupSponsorConfirmComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  getPreRegSponsorPublicInfo: PropTypes.func.isRequired,
}

export default SignupSponsorConfirmComponent
